import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function templateReducer(state: any = initialState.templates, action: any) {
    switch (action.type) {
        case types.LOAD_CONTENT_SUCCESS: {
            return action.templates;
        }
        case types.LOAD_CONTENT_FAILURE: {
            return [];
        }
        default:
            return state;
    }
}

export const getContent = (state) => state.content;
